module.exports = __webpack_public_path__ + "img/style-1.0c548119.jpg";